// React
import { useEffect } from 'react'

// Components
import HeadMeta from '../components/HeadMeta'
import OurStory from '../components/OurStory'
import OurTeam from '../components/OurTeam';
import OurCoreValues from '../components/OurCoreValues';
import OurHoldingGroup from '../components/OurHoldingGroup';

// Images
import AboutUsBanner from '../assets/images/about_us_banner/Cloudxier-aboutus-banner.png'

function AboutUs() {
  // Scroll window to top on load
  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }, [])

  return (
    <div style={{ overflow: 'hidden', paddingTop: '100px' }}>
      <HeadMeta
        title="Cloudxier - About Us"
        description="Our mission is to help accelerating business in their digital innovation"
        siteName="Cloudxier"
        url="https://www.cloudxier.com/about/"
        image={AboutUsBanner} />
      <OurStory />
      <OurTeam />
      <OurCoreValues />
      <OurHoldingGroup />
    </div>
  )

}

export default AboutUs